export enum DocumentStatus {
    Created = 'STATUS_CREATED',
    Ongoing = 'STATUS_ONGOING',
    Completed = 'STATUS_COMPLETED',
    CompletedWithoutTransition = 'STATUS_COMPLETED_WITHOUT_TRANSITION',
    CompletedWithTransition = 'STATUS_COMPLETED_WITH_TRANSITION',
    Canceled = 'STATUS_CANCELED',
    Scheduled = 'STATUS_SCHEDULED',
    Paused = 'STATUS_PAUSED',
}

/**
 * Whether a document is still being worked on.
 *
 * Only open work can run late: a completed or cancelled document has no
 * deadline left to miss, and a paused one is waiting on someone by design.
 */
export const isOpenDocumentStatus = (status: DocumentStatus): boolean =>
    DocumentStatus.Created === status || DocumentStatus.Ongoing === status;
